export default __webpack_public_path__ + "static/chatbot_banner-945501281bc56467e4e7ad7d85be54fe.webp";